import axios from "axios";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;

    // Verify if session has timed out due to inactivity
    const lastActivity = parseInt(sessionStorage.getItem("last_activity_time") || "0", 10);
    const timeoutMinutes = parseInt(sessionStorage.getItem("session_timeout") || "30", 10);

    if (lastActivity > 0 && timeoutMinutes > 0) {
      const elapsedMinutes = (Date.now() - lastActivity) / (60 * 1000);
      if (elapsedMinutes >= timeoutMinutes) {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("last_activity_time");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login?timeout=1";
        }
        return Promise.reject(new Error("Session timed out due to inactivity"));
      }
    }

    // Refresh activity time
    sessionStorage.setItem("last_activity_time", String(Date.now()));
  }

  const storedUser = sessionStorage.getItem("user");
  if (storedUser) {
    try {
      const parsed = JSON.parse(storedUser);
      if (parsed?.id) {
        config.headers["X-User-Id"] = parsed.id;
      }
    } catch (e) {
      // ignore
    }
  }

  return config;
});

// Response interceptor to handle auto logout if user is suspended or unauthenticated
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;
    const isSuspended =
      Boolean(data?.suspended) ||
      (typeof data?.message === "string" &&
        data.message.toLowerCase().includes("suspended"));

    if (status === 401 || (status === 403 && isSuspended)) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");

      if (window.location.pathname !== "/login") {
        const query = isSuspended ? "?suspended=1" : "";
        window.location.href = `/login${query}`;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
